import { combineReducers } from "redux";
import { reducer as applicationReducer } from "./application-store";
import { authorizationGateReducer } from "./authorization-gate/authorization-gate-store";
import { errorReducer } from "./error-viewer/error-store";
import { reducer as itkToastrReducer } from "./itk-toastr/itk-toastr-store";
import { globalSearchReducer } from "./application-wrapper/components/global-search/global-search-store";
import { countriesReducer } from "./countries/countries-store";

export const generalReducer = combineReducers({
  applicationReducer,
  errorReducer,
  authorizationGateReducer,
  itkToastrReducer,
  globalSearchReducer,
  countriesReducer
});
